var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-function area"
  }, [_c("section", {
    staticClass: "product-function__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("FUNCTION")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("功能介绍")])]), _c("section", {
    staticClass: "product-function__introduction"
  }, [_c("div", {
    staticClass: "mode clearfix"
  }, [_c("span", [_vm._v("传统模式：")]), _c("img", {
    attrs: {
      src: require("@/assets/images/service/operating-activities/功能介绍-传统模式.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "mode clearfix"
  }, [_c("span", [_vm._v("同顺模式：")]), _c("img", {
    attrs: {
      src: require("@/assets/images/service/operating-activities/功能介绍-同顺模式.png"),
      alt: ""
    }
  })])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };